<template>
  <div>
    <el-card>
      <el-form ref="form" :model="form" :rules="handRules" class="emcdForm" label-width="220px">
        <el-row>
          <el-col :span="24">
            <el-form-item class="rowc" label="手裁用量：" prop="rfid_handcut_phr">
              <el-input
                ref="rfid_handcut_phr_ref"
                v-model="form.rfid_handcut_phr"
                maxlength="9"
                show-word-limit
                @input="form.rfid_handcut_phr = keepNum99(form.rfid_handcut_phr)"
                @keyup.enter.native="rfid_handcut_phrKeyup"
              >
                <template slot="append">片</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-row>-->
        <!--  <el-col :span="12" class="rowc">-->
        <!--    <el-form-item label="试样片数：" prop="sample_phr">-->
        <!--      <el-input-->
        <!--        ref="sample_phr_ref"-->
        <!--        v-model="form.sample_phr"-->
        <!--        maxlength="9"-->
        <!--        show-word-limit-->
        <!--        @input="form.sample_phr = helper.keepTNum(form.sample_phr)"-->
        <!--        @keyup.enter.native="sample_phrKeyup"-->
        <!--      >-->
        <!--        <template slot="append">片</template>-->
        <!--      </el-input>-->
        <!--    </el-form-item>-->
        <!--  </el-col>-->
        <!--  <el-col :span="12" class="rowc">-->
        <!--    <el-form-item label="试样个数：" prop="sample_num">-->
        <!--      <el-input-->
        <!--        ref="sample_numRef"-->
        <!--        v-model="form.sample_num"-->
        <!--        maxlength="9"-->
        <!--        show-word-limit-->
        <!--        @input="form.sample_num = helper.keepTNum(form.sample_num)"-->
        <!--      >-->
        <!--        <template slot="append">个</template>-->
        <!--      </el-input>-->
        <!--    </el-form-item>-->
        <!--  </el-col>-->
        <!--</el-row>-->
        <el-row>
          <el-col :span="12" class="rowc">
            <el-form-item label="岗位：" prop="rfid_handcut_post">
              <el-input v-model="form.rfid_handcut_post" disabled maxlength="9" show-word-limit> </el-input>
            </el-form-item>
            <el-form-item label="填卡人：" prop="card_user_id">
              <el-select v-model="form.card_user_id" disabled filterable placeholder="请选择">
                <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工序制作人：" prop="stff_id">
              <el-select v-model="form.stff_id" filterable placeholder="请选择">
                <el-option v-for="item in stffList2" :key="item.stff_id" :label="item.stff_name" :value="item.stff_id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item>
              <sub-table ref="subTable" :stffList="stffList2" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item align="center" class="ml_10">
          <el-button class="determine" type="success" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!--   提交 -->
    <el-dialog :visible.sync="emcdDialogVisible" width="70%">
      <h2 class="diaTitle">提示：提交手裁信息, 是否继续</h2>
      <div class="diaContent">
        <el-button class="determine" @click="emcdDialogVisible = false">取 消</el-button>
        <el-button class="determine" type="primary" @click="emcdDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '@api/request';
import { rfidAPI } from '@api/modules/rfid';
import helper from '@assets/js/helper.js';
import SubTable from '@/views/OperateManagement/ReadManage/TabChild/subTable.vue';

export default {
  components: { SubTable },
  computed: {
    helper() {
      return helper;
    }
  },
  data() {
    return {
      form: {
        rfid_handcut_phr: '',
        card_user_id: '',
        stff_id: '',
        sample_phr: '',
        sample_num: '',
        stff_name: '',
        rfid_handcut_post: ''
      },
      handRules: {
        rfid_handcut_phr: [
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' },
          { required: true, message: '请填写手裁用量', trigger: true }
        ]
      },
      emcdDialogVisible: false
    };
  },
  props: {
    prop: {
      type: Object
    },
    stffList: {
      type: Array
    },
    stffList2: {
      type: Array
    }
  },
  methods: {
    submit() {
      if (!this.prop.rfid_id) {
        return this.$message.error('请刷卡');
      }
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.emcdDialogVisible = true;
        }
      });
    },
    emcdDialog() {
      this.emcdDialogVisible = false;
      let form = {};
      form.rfid_id = this.prop.rfid_id;
      form.user_id = this.prop.user_id;
      // form.stff_id = this.prop.stff_id;
      form.user_rfid_no = this.prop.user_rfid_no;
      form.rfid_handcut_phr = this.form.rfid_handcut_phr;
      form.card_user_id = this.form.card_user_id ? this.form.card_user_id : this.$cookies.get('userInfo').user_id;
      form.stff_id = this.form.stff_id ? this.form.stff_id : this.$cookies.get('userInfo').stff_id;
      form.stff_name = this.stffList2.find(item => item.stff_id === form.stff_id).stff_name;
      form.user_id = this.stffList.find(item => item.stff_id === form.stff_id).user_id;
      form.sample_phr = this.form.sample_phr;
      form.sample_num = this.form.sample_num;
      // form.stff_name = this.form.stff_name;
      form.rfid_handcut_post = this.prop.user_jobs; //岗位
      form.rfid_handcut_id = this.prop.rfid_handcut_id;
      form.rfidProcessItems = this.$refs.subTable.tableData.filter(x => (x.rfid_handcut_id ? true : !x.rfid_handcut_id && !x.destroy_flag));
      post(rfidAPI.edit_handCut, form)
        .then(res => {
          if (res.data.code !== 0) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success(res.data.msg);
          this.$refs['form'].resetFields();
          this.$emit('empty');
        })
        .catch(res => {
          this.$message.error(res.data.msg);
        });
    },
    rfid_handcut_phrKeyup() {
      this.$refs.sample_phr_ref.focus();
    },
    sample_phrKeyup() {
      this.$refs.sample_numRef.focus();
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  mounted() {
    this.$EventBus.$on('handCut', () => {
      this.form.rfid_handcut_phr = '';
      this.form.card_user_id = '';
      this.form.stff_id = '';
      this.form.sample_phr = '';
      this.form.sample_num = '';
      this.form.stff_name = '';
      this.form.rfid_handcut_post = '';
    });
    this.$EventBus.$on('handCutEmit', res => {
      this.form.rfid_handcut_phr = res.rfid_handcut_phr;
      this.form.card_user_id = res.card_user_id;
      this.form.stff_id = res.stff_id;
      this.form.sample_phr = res.sample_phr;
      this.form.sample_num = res.sample_num;
      this.form.stff_name = res.stff_name;
      this.form.rfid_handcut_post = res.rfid_handcut_post;
      if (!this.$refs.handCutRef) {
        return;
      } else {
        this.$refs.handCutRef.focus();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.emcdForm .el-form-item {
  margin-bottom: 10px;
}

.emcdForm {
  width: 90%;
  margin: 0 auto;
  min-width: 500px;
}

::v-deep .emcdForm .el-form-item__label {
  font-size: $font-max;
}

::v-deep .emcdForm .el-input {
  font-size: $font-max;
  height: 60px;
}

::v-deep .el-form-item__content {
  margin-bottom: 20px;
}

::v-deep .emcdForm .el-input input {
  height: 60px;
}

::v-deep .el-form-item__error {
  font-size: 18px;
  margin-bottom: 2px;
}
</style>
